module.exports = __webpack_public_path__ + "static/media/picto-pink-fixed.566e3e7f.png";